@if (product().code && !product().oneCall) {
  @if (displayDescription()) {
    {{ 'productDetails.code' | transloco }}:
  }
  {{ product().code }}
}
